<template>
    <div class="footer-warpper" :class="{black:isBlack}">
        Copyright {{ COPYRIGHT_ORG }} <a :class="{black:isBlack}"  class="margin-left-xs" target="_blank" href="http://beian.miit.gov.cn">{{ COPYRIGHT_ICP }}</a><img class="beian" src="../../../assets/img/beian.png">
        <a :class="{black:isBlack}" class="margin-right-xs" target="_blank" :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${COPYRIGHT_GA_CODE}`">{{ COPYRIGHT_GA_NAME }}{{ COPYRIGHT_GA_CODE }}号</a>
        {{ COPYRIGHT_COMPANY }}  版权所有
    </div>
</template>
<script>
import {COPYRIGHT_COMPANY, COPYRIGHT_GA_CODE, COPYRIGHT_GA_NAME, COPYRIGHT_ICP, COPYRIGHT_ORG} from "@/config";

export default {
    name: "FooterModular",
    data() {
        return {
            COPYRIGHT_ORG:COPYRIGHT_ORG,
            COPYRIGHT_COMPANY:COPYRIGHT_COMPANY,
            COPYRIGHT_ICP:COPYRIGHT_ICP,
            COPYRIGHT_GA_CODE:COPYRIGHT_GA_CODE,
            COPYRIGHT_GA_NAME:COPYRIGHT_GA_NAME,
        }
    },
    props: {
        isBlack: {
            type: Boolean,
            default: false
        }
    },
    created() {
    },
    methods: {}
}
</script>

<style scoped lang="scss">
.footer-warpper {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: #051b36;
    color: #ffffff;
    &.black {
        background-color: #2f2f2f;
        color: #f5f5f5;
    }
    .beian{
        width: 15px;
        height: 15px;
        margin: 0 5px;
    }
    a {
        font-size: 14px;
        line-height: 14px;
        color: #ffffff;
        &.black {
            color: #f5f5f5;
        }
    }
}
</style>